import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-category" }

import { ref, computed, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

import {
  TranslationFieldsType,
  TranslationType,
} from "@/common/types/translation";

import {
  baseInput,
  baseSelect,
  baseTextarea,
  baseTextEditor,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-translate',
  props: {
    fields: {},
    data: {},
    language: {}
  },
  emits: ["update:data", "salve:data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const language = ref("");
const payload = ref<{ [key: string]: string }>({});

const languagesOptions = computed(() => [
  {
    option: "Português (BR)",
    value: "pt-br",
  },
  {
    option: "English (US)",
    value: "en-us",
  },
]);

function update() {
  emit("update:data", {
    language: language.value,
    metadata: JSON.stringify(payload.value),
  });
}

function resumeData() {
  if (!props.fields) return;

  payload.value = props.fields?.reduce((acc, item) => {
    acc[item.field] = item.value;
    return acc;
  }, {});

  if (props.data) {
    language.value = props.data.language;

    if (props.data?.metadata) {
      try {
        const metadata = props.data.metadata;

        if (metadata) {
          props.fields?.forEach((item) => {
            if (metadata[item.field]) {
              payload.value[item.field] = metadata[item.field];
            }
          });
        }
      } catch (_) {}
    }
  }
}

watchEffect(() => {
  resumeData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_unref(baseSelect), {
      modelValue: language.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
      value: language.value,
      options: languagesOptions.value,
      "is-empty": false,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (update()))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "options"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.fields, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.field
      }, [
        (item.type === 'input')
          ? (_openBlock(), _createBlock(_unref(baseInput), {
              key: 0,
              modelValue: payload.value[item.field],
              "onUpdate:modelValue": ($event: any) => ((payload.value[item.field]) = $event),
              value: payload.value[item.field],
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (update()))
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)(item.label)), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "value"]))
          : _createCommentVNode("", true),
        (item.type === 'textarea')
          ? (_openBlock(), _createBlock(_unref(baseTextEditor), {
              key: 1,
              modelValue: payload.value[item.field],
              "onUpdate:modelValue": ($event: any) => ((payload.value[item.field]) = $event),
              onBlur: _cache[3] || (_cache[3] = ($event: any) => (update()))
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)(item.label)), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})